/* Using MaterialUI hook here, to be extracted if Mui will ever be removed */
export { useForkRef } from '@material-ui/core';
//# sourceMappingURL=useForkRef.js.map